import { createSelector } from '@ngrx/store';

import { loylatyProductProgramsState } from '../root';

export const getLoyaltyProductPrograms = createSelector(loylatyProductProgramsState, (loyaltyProductPrograms) => loyaltyProductPrograms);
